import React, { useState } from 'react';

const LoginPage = ({ onLogin }) => {
  const [key, setKey] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();

    if (key === 'ehr12345') {
      onLogin();
    } else {
      setError('Invalid key. Please try again.');
    }
  };

  const styles = {
    loginPage: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
    },
    input: {
      marginBottom: '10px',
      padding: '5px',
      border: '1px solid #000',
      borderRadius: '4px', 
      width: '250px'
    },
    buttonContainer: {
      textAlign: 'center',
      marginTop: '10px'
    },
    button: {
      padding: '5px 10px',
      backgroundColor: 'black',
      color: 'white',
      border: 'none', 
      borderRadius: '4px', 
      cursor: 'pointer'
    },
    error: {
      color: 'red',
      marginTop: '10px',
    },
  };

  return (
    <div style={styles.loginPage}>
      <h1>SimplifAI</h1>
      <p> Please enter your API key to access the demo.</p>
      <div style={{ height: '2vh' }}></div>
      <form onSubmit={handleSubmit}>
        <div>
          <input
            type="password"
            placeholder="Enter Key"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            style={styles.input}
          />
        </div>
        <div style={styles.buttonContainer}>
          <button type="submit" style={{ ...styles.button, boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)', padding: '15px' }}>
            Login
          </button>
        </div>
      </form>
      {error && <p style={styles.error}>{error}</p>}
    </div>
  );
};

export default LoginPage;
